import { isProd } from '../../../utils/isProd/isProd.web';

const STAG_API_HOST_KEY = 'stag-api-host';

const getStage = (): string => {
  const stagName = new URLSearchParams(document.location.search).get('stag');
  if (stagName) {
    localStorage.setItem(STAG_API_HOST_KEY, stagName);
    return stagName;
  }
  const stored = localStorage.getItem(STAG_API_HOST_KEY);
  if (stored) {
    return stored;
  }
  const label = document.location.hostname.split('.')[0];
  return label.startsWith('stag') ? label : 'stag';
};

export const getAPIHost = () => {
  if (isProd()) {
    return 'https://api.a-bly.com';
  }
  return `https://${getStage()}.api.a-bly.com`;
};
